import React from 'react'
import ShutdownHome from '../shutdown/ShutdownHome'

// Platform has been shut down - show shutdown notice instead of regular home
const HomeMain = () => {
  return <ShutdownHome />
}

export default HomeMain
